import React from "react"
import PropTypes from "prop-types"

const FormLoader = props => (
  <div className={`form-loader ${props.className}`}>
    <div className="form-loader__item form-loader__item--input"></div>
    <div className="form-loader__split">
      <div className="form-loader__item form-loader__item--input"></div>
      <div className="form-loader__item form-loader__item--input"></div>
    </div>
    <div className="form-loader__item form-loader__item--input"></div>
    <div className="form-loader__item form-loader__item--input"></div>
    <div className="form-loader__item form-loader__item--input"></div>
    <div className="form-loader__split form-loader__split--checkbox">
      <div className="form-loader__item form-loader__item--checkbox"></div>
      <div className="form-loader__item form-loader__item--label"></div>
    </div>
    <div className="form-loader__split form-loader__split--checkbox">
      <div className="form-loader__item form-loader__item--checkbox"></div>
      <div className="form-loader__item form-loader__item--label"></div>
    </div>
    <div className="form-loader__item form-loader__item--button"></div>
  </div>
)

FormLoader.propTypes = {
  className: PropTypes.string,
}

export default FormLoader
